<template>
  <div id="app">
    <Navigation></Navigation>
    <Home></Home>
    <Modals></Modals>
  </div>
</template>

<script>
import Navigation from "./components/Navigation";
import Home from "./components/Home";
import Modals from "./components/Modals";
export default {
  name: "App",
  data() {
    return {
      selectedItem: "",
    };
  },
  components: {
    Home,
    Navigation,
    Modals,
  },
};
</script>

<style>
#app {
  height: 100% !important;
  margin: 0;
}
.content {
  height: 100%;
  overflow: auto;
}
@media (max-width: 992px) {
  .w3-sidebar.w3-collapse {
    display: none;

    height: auto !important;
    width: 100% !important;
  }
  h5 {
    font-size: 14px;
  }
  p {
    font-size: 12px;
  }
}
</style>
